var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6782 4.5328L11.4628 1.3214C11.2552 1.114 10.9794 1 10.686 1C10.6855 1 10.685 1 10.6845 1C10.3906 1.0005 10.1149 1.1154 9.9077 1.3234L1.3577 9.9097C1.155 10.1137 1.0418 10.3837 1.0388 10.6699L1.0001 13.8901C0.996196 14.1899 1.1117 14.4718 1.3253 14.683C1.5329 14.888 1.8058 15 2.0962 15C2.105 15 2.1139 15 2.1227 15L5.393 14.9276C5.6771 14.9213 5.9445 14.8073 6.1453 14.6062L14.6782 6.0839C14.8859 5.8765 15 5.6011 15 5.3081C15 5.0156 14.8859 4.7402 14.6782 4.5328ZM5.3705 13.9257L2.1002 13.9981L2.0032 13.9022L2.0419 10.6816L8.6912 3.9742L12.0272 7.3064L5.3705 13.9257ZM13.9689 5.3756L12.7378 6.5997L9.3968 3.2623L10.6188 2.0296H10.7535L13.9689 5.241C14.0008 5.2729 14.0008 5.3438 13.9689 5.3756Z",
    fill: "#0072C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTheme);
export default __webpack_public_path__ + "static/media/EditTheme.d2299d0d77937cc4a270da1a171d4a51.svg";
export { ForwardRef as ReactComponent };